import './modal-rate-quote'

import * as d3 from 'd3';
import {
  cleanNumberRegex,
  currencyFormat,
  currencyDecimalFormat,
  calculateMonthlyPayment,
  formatCalculatorValue,
  updateFormattedInputSelection,
} from './utils'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default (function() {

  /* eslint-disable no-unused-vars */
  var mortCalc = document.querySelector('.js-mortgage-calculator');
  var submit = document.querySelector('.js-btn-calculate')
  function init() {

    if (!mortCalc) {
      return;
    }

    let ctaBanner = document.querySelector('.calculator-cta-banner')
    if (ctaBanner) {
      ScrollTrigger.create({
        trigger: ".js-cta-banner-trigger",
        start: "bottom top",
        onEnter: self => {
          ctaBanner.classList.add('active')
        },
        onLeaveBack: self => {
          ctaBanner.classList.remove('active')
        }
      });
    }

    const arc = d3.arc();

    let colors = {
      principal_interest: '#188A61',
      taxes: '#86E077',
      hazard_insurance: '#DEFF67',
      mortgage_insurance: '#F57F52',
    };

    // set the dimensions and margins of the graph
    const width = 375,
      height = 375,
      margin = 0;
    // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
    const radius = Math.min(width, height) / 2 - margin;

    // append the svg object to the div called 'my_dataviz'
    const svg = d3
      .select('#graph')
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .attr('viewBox', `0 0 ` + width + ` ` + height)
      .attr('preserveAspectRatio', `xMidYMid meet`)
      .append('g')
      .attr('transform', `translate(${width / 2}, ${height / 2})`);
    const g = svg.select('g');

    const data = {
      principal_interest: 300,
      taxes: 55,
      hazard_insurance: 45,
      mortgage_insurance: 80,
    };

    // let labels = {
    //   principal_interest: 'Principal & Interest',
    //   taxes: 'Taxes',
    //   hazard_insurance: 'Hazard Insurance',
    //   mortgage_insurance: 'Mortgage Insurance',
    // };
    // Compute the position of each group on the pie:
    const pie = d3.pie().value(function(data) {
      return data[1];
    });

    const arcGenerator = d3
      .arc()
      .innerRadius(radius * 0.77)
      .outerRadius(radius);

    let labelArcGenerator = d3
      .arc()
      .innerRadius(radius + 20)
      .outerRadius(radius + 20);

    function arcTween() {
      return function(d) {
        // interpolate both its starting and ending angles
        var interpolateStart = d3.interpolate(d.start.startAngle, d.end.startAngle);
        var interpolateEnd = d3.interpolate(d.start.endAngle, d.end.endAngle);
        return function(t) {
          return arc({
            startAngle: interpolateStart(t),
            endAngle: interpolateEnd(t),
          });
        };
      };
    }
    let rendered = false;

    function updatePie(data) {
      const data_ready = pie(Object.entries(data));

      if (rendered) {
        svg.selectAll('path').data(data_ready);
      } else {
        svg
          .selectAll('slices')
          .data(data_ready)
          .enter()
          .append('path')
          .attr('d', arcGenerator)
          .attr('fill', function(d) {
            // return a specific color by key
            return colors[d.data[0]];
          });
      }
    }

    updatePie(data);

    const handleInputMouseUp = (event) => {
      event.target.removeEventListener('mouseup', handleInputMouseUp)
      event.target.removeEventListener('keyup', handleInputMouseUp)
      updateFormattedInputSelection(event.target)
    }

    // submit.addEventListener('click', function() {
    //   runCalculation()
    // });

    var inputs = document.querySelectorAll('input[type="text"]');
    inputs.forEach(function(input) {
      input.addEventListener('input', function(event) {
        runCalculation()
      });

      input.addEventListener('blur', function(event) {

        runCalculation()

        let format = event.target.dataset.format
        if (!format) {
          return;
        }

        let formattedValue = formatCalculatorValue(event.target.value, format)
        event.target.value = formattedValue
      });

      // On focus, switch to using just numeric value
      input.addEventListener('focus', (event) => {
        event.target.addEventListener('mouseup', handleInputMouseUp)
        event.target.addEventListener('keyup', handleInputMouseUp)
      })
    });

    var purchasePrice = document.querySelector('.p-price')
    var moneyValue = document.querySelector('.d-payment');
    var percentageValue = document.querySelector('.d-payment-percentage');
    var loanAmount = document.querySelector('.loan-amt')
    var connects = document.querySelectorAll('.connected');

    let downPaymentAmount = parseFloat(moneyValue.value.replace(cleanNumberRegex, ''));
    let precentageDownAmount = parseFloat(percentageValue.value.replace(cleanNumberRegex, ''))

    connects.forEach(function(connect) {
      connect.addEventListener('blur', (event) => {

          var mortgagePrice = parseFloat(purchasePrice.value.replace(cleanNumberRegex, ''));
          var downPayment = parseFloat(moneyValue.value.replace(cleanNumberRegex, ''));
          var percentageDownValue = parseFloat(percentageValue.value.replace(cleanNumberRegex, ''));

          const currentField = event.target
          if (currentField.classList.contains('d-payment-percentage')) {

            if (precentageDownAmount != percentageDownValue) {
              moneyValue.value = currencyDecimalFormat.format(Math.floor(mortgagePrice * (percentageDownValue / 100)))
              downPaymentAmount = moneyValue.value
            }

          } else if (connect.classList.contains('d-payment') || connect.classList.contains('p-price')) {

            if (connect.classList.contains('p-price') || downPaymentAmount != downPayment) {
              percentageValue.value = `${ ((downPayment / mortgagePrice) * 100).toFixed(1) }%`;
              loanAmount.value = currencyDecimalFormat.format(mortgagePrice - downPayment)
              precentageDownAmount = percentageValue.value
            }
          }
      });
    });

    function runCalculation() {
      var downPayment = document
        .querySelector('.d-payment')
        .value.replace(cleanNumberRegex, '');
      var mortgagePrice = document
        .querySelector('.p-price')
        .value.replace(cleanNumberRegex, '');
      var loanAmount = document.querySelector('.loan-amt')
      var purchasePrice = parseFloat(mortgagePrice - downPayment);
      var mortgagePeriod = (parseInt(document.querySelector('.m-period').value.replace(cleanNumberRegex, '')) || 1) * 12;
      var interestRate = (parseFloat(document.querySelector('.i-rate').value.replace(cleanNumberRegex, '')) || 0) / 12 / 100;
      var hazardInsurance = parseFloat(
        document.querySelector('.hazard-insurance').value.replace(cleanNumberRegex, '') || 0
      );
      var mortgageInsurance = parseFloat(
        document.querySelector('.mortgage-insurance').value.replace(cleanNumberRegex, '') || 0
      );
      var propertyTaxes = parseFloat(document.querySelector('.property-taxes').value.replace(cleanNumberRegex, '') || 0);

      let principalWithInterest = calculateMonthlyPayment(purchasePrice, interestRate, mortgagePeriod)
      let totalPayment = principalWithInterest + hazardInsurance + mortgageInsurance + propertyTaxes

      let totalFinanced = mortgagePrice - downPayment;
      loanAmount.value = currencyDecimalFormat.format(Math.max(0, totalFinanced))

      document.querySelector('.monthly-payment-value').innerHTML = currencyFormat.format(totalPayment).replace('$', '') // We like the $ in a different font
      document.querySelector('.monthly-payment-amount').innerHTML = currencyFormat.format(totalPayment)

      var legend = document.querySelector('.legend');
      var piHTML = legend.querySelector('.pi-total');
      var miHTML = legend.querySelector('.mi-total');
      var hiHTML = legend.querySelector('.hi-total');
      var txHTML = legend.querySelector('.tx-total');

      piHTML.innerHTML = currencyFormat.format(principalWithInterest)
      miHTML.innerHTML = currencyFormat.format(mortgageInsurance)
      hiHTML.innerHTML = currencyFormat.format(hazardInsurance);
      txHTML.innerHTML = currencyFormat.format(propertyTaxes);

      const data = {
        principal_interest: principalWithInterest,
        taxes: propertyTaxes,
        hazard_insurance: hazardInsurance,
        mortgage_insurance: mortgageInsurance,
      };

      updatePie(data);
    }

    runCalculation()
  }

  return {
    init: init,
  }


  /* eslint-enable no-unused-vars */

})()
